export default __webpack_public_path__ + "static/media/expand.3948132f.svg";